import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Utility from '../../../util/utilityfunctions';

import OutputText from '@ey/canvascoreservices/OutputText';

const MetricsTileLabel = ({title, warningText, onGraphicClick, content}) => {
	const getOutOfLabel = (content) => {
		return Utility.getSanitizedText(content, false);
	};

	return (
		<StyledMetricsTileLabel onClick={onGraphicClick}>
			<OutputText body3 title={title} ellipsis>
				{title}
			</OutputText>
			<div className="subtitle">
				<OutputText body3 light dangerouslySetInnerHTML={{__html: getOutOfLabel(content)}} />
				<OutputText body3 light className="warning-text">
					{warningText}
				</OutputText>
			</div>
		</StyledMetricsTileLabel>
	);
};

MetricsTileLabel.defaultProps = {
	title: '',
	content: '',
	warningText: '',
	onGraphicClick: () => {}
};

MetricsTileLabel.propTypes = {
	title: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	warningText: PropTypes.string,
	onGraphicClick: PropTypes.func
};

export default MetricsTileLabel;

const StyledMetricsTileLabel = styled.div`
	color: var(--neutrals-700);
	.subtitle {
		display: flex;
		gap: var(--spacing-medium);
		justify-content: space-between;
		.warning-text {
			color: var(--red-600);
		}
	}
`;
